function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
// GENERATED BY ./scripts/generate.ts
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import AnthropicFilledSvg from '@ant-design/icons-svg/lib/asn/AnthropicFilled';
import AntdIcon from "../components/AntdIconLight";
const AnthropicFilled = (props, ref) => /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
  ref: ref,
  icon: AnthropicFilledSvg
}));

/**![anthropic](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTcxMC4wMiAxOTYuMkg1NzIuOTRsMjQ5Ljk4IDYzMS42SDk2MHptLTM5Ni4wNCAwTDY0IDgyNy44aDEzOS43OGw1MS4xMi0xMzIuNjNoMjYxLjUzbDUxLjEyIDEzMi42NGgxMzkuNzlMNDU3LjM2IDE5Ni4xOXptLTEzLjg2IDM4MS42Nmw4NS41NS0yMjEuOTcgODUuNTQgMjIxLjk3eiIgLz48L3N2Zz4=) */
const RefIcon = /*#__PURE__*/React.forwardRef(AnthropicFilled);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'AnthropicFilled';
}
export default RefIcon;